'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _components = require('../../components');

var _PackagePromotion = require('./PackagePromotion.scss');var _PackagePromotion2 = _interopRequireDefault(_PackagePromotion);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Styles
var PackagePromotion = function (_Component) {_inherits(PackagePromotion, _Component);function PackagePromotion() {var _temp, _this, _ret;_classCallCheck(this, PackagePromotion);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.




    getLabelKey = function (type) {
      switch (type) {
        case 'top_promotion':return 'top_promotion';
        case 'highlight':return 'highlights';
        case 'autoJump':return 'jumping';
        default:return '';}

    }, _this.

    getRestrictionKey = function (type) {
      switch (type) {
        case 'top_promotion':return 'restriction_to_add_top_promotions';
        case 'highlight':return 'restriction_to_add_promotions';
        default:return null;}

    }, _this.

    renderPromotionIcon = function (type, iconName, count, disabled, allowed) {var _cx;
      var countValue = (typeof _this.props.defaultPromoted === 'number' ? _this.props.defaultPromoted : count) || 0;
      var status = disabled ? '-disabled' : '-active';
      var icon = '' + iconName + status;
      var label = _this.getLabelKey(type);
      var rtlSymbol = String.fromCharCode(8207);
      var startString = _this.props.isRtl ? rtlSymbol + ':' : ':';
      var counter = _this.props.isShort ? '' + countValue :
      startString + ' ' + countValue + ' ' + _this.props.translate('of') + ' ' + allowed;

      return (
        _react2.default.createElement('span', { className: (0, _classnames2.default)(_PackagePromotion2.default.packageIcon, _this.props.packageStyle, (_cx = {}, _cx[_PackagePromotion2.default.disabled] = disabled, _cx)) },
          _react2.default.createElement('i', { className: 'icon icon-' + icon },
            _react2.default.createElement('span', { className: 'path1' }),
            _react2.default.createElement('span', { className: 'path2' }),
            _react2.default.createElement('span', { className: 'path3' })),

          !_this.props.regularUser &&
          _react2.default.createElement('span', { className: (0, _classnames2.default)(_PackagePromotion2.default.iconLabel, _this.props.labelStyle) },
            _react2.default.createElement('span', null, !_this.props.isShort && _this.props.translate(label)),
            _react2.default.createElement('span', { className: _this.props.counter }, counter))));



    }, _temp), _possibleConstructorReturn(_this, _ret);}PackagePromotion.prototype.

  render = function render() {var _props =
    this.props,translate = _props.translate,promotions = _props.promotions,packageName = _props.packageName,iconName = _props.iconName,defaultPromoted = _props.defaultPromoted,userProperties = _props.userProperties;var
    promoted = promotions.promoted,allowed = promotions.allowed,until = promotions.until;

    var today = (0, _moment2.default)();
    var promotionUntilDate = until && (0, _moment2.default)(until);
    var promotionUntilDateFormatted = promotionUntilDate && promotionUntilDate.utc().format('DD/MM/YYYY') || '-';
    var promotionUntilFormatted = promotionUntilDate && today > promotionUntilDate ? '-' : promotionUntilDateFormatted;

    var restrictionKey = this.getRestrictionKey(packageName);
    var restrictionToAddPromotions = restrictionKey && (
    (0, _get2.default)(
    userProperties, 'data.meta.user_properties.' +
    restrictionKey + '.user_properties') ||
    (0, _get2.default)(
    userProperties, 'meta.' +
    restrictionKey + '.user_properties') ||
    {});

    var canPromote = until || promotionUntilDate && today > promotionUntilDate;

    var allowedToPromote = void 0;
    if (restrictionToAddPromotions.restricted) {
      allowedToPromote = restrictionToAddPromotions.count;
    } else {
      allowedToPromote = allowed - promoted;
    }

    var message = canPromote ?
    _react2.default.createElement('div', { className: _PackagePromotion2.default.tooltipMessage },
      _react2.default.createElement('div', null, translate(packageName + 'Description')),
      _react2.default.createElement('hr', { className: _PackagePromotion2.default.delimiter }),
      _react2.default.createElement('div', null,
        translate(packageName + 'Remaining') + ': ' + (typeof this.props.defaultPromoted === 'number' ? defaultPromoted : allowedToPromote) + ' ' + translate('of') + ' ' + allowed),

      _react2.default.createElement('div', null,
        translate('validUntil') + ': ' + promotionUntilFormatted)) :



    _react2.default.createElement('div', { className: _PackagePromotion2.default.tooltipMessage }, translate(packageName + 'Description'));


    var icon = this.renderPromotionIcon(
    packageName,
    iconName,
    promotionUntilDate ? allowedToPromote : undefined,
    !(allowed - promoted),
    allowed);


    return (
      _react2.default.createElement(_components.BottomTooltip, {
        showOnHover: !this.props.isShort,
        className: 'promotionIconTooltip',
        msg: message,
        icon: icon,
        packageName: packageName,
        closeOnClickOutside: this.props.isShort }));


  };return PackagePromotion;}(_react.Component);PackagePromotion.defaultProps = { packageStyle: '', labelStyle: '', counter: '' };exports.default = PackagePromotion;


PackagePromotion.propTypes = {
  translate: _propTypes2.default.func,
  userProperties: _propTypes2.default.object,
  promotions: _propTypes2.default.object,
  packageName: _propTypes2.default.string,
  defaultPromoted: _propTypes2.default.number,
  iconName: _propTypes2.default.string,
  regularUser: _propTypes2.default.bool,
  isManagePropsPage: _propTypes2.default.bool,
  packageStyle: _propTypes2.default.string,
  labelStyle: _propTypes2.default.string,
  counter: _propTypes2.default.string,
  isShort: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PackagePromotion/PackagePromotion.js
// module id = 2773
// module chunks = 0